import { z } from 'zod';
import { SelectorsQuerySchema } from './selectors.js';
export const EXPORT_KINDS = ['levels', 'growth', 'daily'];
export const ExportKindSchema = z.enum(EXPORT_KINDS);
export const ExportFormatSchema = z.enum(['tsv', 'xlsx']);
export const ExportQuerySchema = SelectorsQuerySchema.extend({
    format: ExportFormatSchema.default('tsv'),
});
//# sourceMappingURL=exports.js.map